import { Pipe, PipeTransform } from '@angular/core';
import { UserType, Optional } from '@lib/interfaces';

@Pipe({
    name: 'userType',
    standalone: true,
})
export class UserTypePipe implements PipeTransform {
    public transform(value: Optional<UserType>): string {
        switch (value) {
            case UserType.BUSINESS:
                return 'Business';
            case UserType.DIRECTOR:
                return 'Director';
            case UserType.INDIVIDUAL:
                return 'Individual';
            case UserType.SHAREHOLDER:
                return 'Shareholder';
            case UserType.SHAREHOLDER_BUSINESS:
                return 'Shareholder Business';
            case UserType.SIGNATURE:
                return 'Signature';
            case UserType.AGENT:
                return 'Agent';
            default:
                return '';
        }
    }
}
